// extracted by mini-css-extract-plugin
module.exports = {"skeletonItem":"Waiting_skeletonItem_RgBqF","errorText":"Waiting_errorText_23aka"};